import { LogEventNames } from '../interfaces/ITelemetryLogger';
import { HostAppName } from '../office-js/HostAppSettings';
import { HostAppUtil } from '../office-js/HostAppUtil';
import { LogError } from '../../utils/ErrorTelemetry';
import { OneNoteEventNotifier } from '../OneNote/OneNoteEventNotifier';
import { IEventListener } from '../interfaces/IEventListener';

export const InitializeHostAppNotifer = () : IEventListener | undefined => {
  const hostAppName = HostAppUtil.GetHostAppName();
  switch (hostAppName) {
    case HostAppName.ONENOTE:
      return new OneNoteEventNotifier();
    default:
      LogError(LogEventNames.Warning, "Requested Host App Notifier for current app name is not supported");
      return undefined;
  }
}
